import { STALE_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const roomTypeConfig = {
  createRoomType: {
    key: "createRoomType",
    url: "/api/v1/room-types",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getRoomTypes"],
      onSuccessMessage: "Room type created successfully",
      onErrorMessage: "Failed to create room type",
    },
  },

  getRoomTypes: {
    key: "getRoomTypes",
    url: "/api/v1/room-types",
    method: "GET",
    options: {
      retry: 2,
      staleTime: STALE_TIME.LOW_LATENCY,
      refetchInterval: 30_000,
      refetchOnWindowFocus: true,
    },
  },

  getRoomTypeById: {
    key: "getRoomTypeById",
    url: (data) => `/api/v1/room-types/${data.id}`,
    method: "GET",
    options: {
      retry: 2,
    },
  },

  updateRoomType: {
    key: "updateRoomType",
    url: (data) => `/api/v1/room-types/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getRoomTypes", "getRoomTypeById"],
      onSuccessMessage: "Room type updated successfully",
      onErrorMessage: "Failed to update room type",
    },
  },

  getDeletedRoomTypes: {
    key: "getDeletedRoomTypes",
    url: "/api/v1/room-types/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  deleteRoomType: {
    key: "deleteRoomType",
    url: (data) => `/api/v1/room-types/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getRoomTypes", "getDeletedRoomTypes"],
      onSuccessMessage: "Room type deleted successfully",
      onErrorMessage: "Failed to delete room type",
    },
  },

  restoreRoomType: {
    key: "restoreRoomType",
    url: (data) => `/api/v1/room-types/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getRoomTypes", "getDeletedRoomTypes"],
      onSuccessMessage: "Room type restored successfully",
      onErrorMessage: "Failed to restore room type",
    },
  },
};
